import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PostReservationState} from '../../../../../../models/postReservationState';
import {GlobalConstantsComponent} from '../../../../../../shared/global-constants/global-constants.component';
import {DocumentsService} from '../../../../../../services/user-services/documents.service';
import {finalize, first} from 'rxjs/operators';
import {NgClass, NgForOf, NgIf, NgOptimizedImage, NgTemplateOutlet} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {UserService} from '../../../../../../services/user-services/user.service';
import {AlertService} from '../../../../../../services/alert.service';

@Component({
  selector: 'app-template-step',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslateModule,
    NgForOf,
    NgClass,
    NgIf,
    NgTemplateOutlet
  ],
  templateUrl: './template-step.component.html',
  styleUrl: './template-step.component.scss'
})
export class TemplateStepComponent implements OnChanges, OnInit {

  // Renvoi true quand il clique sur "contacte le propriétaire/le partenaire"
  @Output() public wantContactPage: EventEmitter<boolean> = new EventEmitter<boolean>();
  //
  @Output() public wantOtherStep: EventEmitter<PostReservationState> = new EventEmitter<PostReservationState>();
  // étape affichée
  @Input() public readonly displayedStep: PostReservationState;
  // langue de l'utilisateur
  @Input() public locale: string = 'en';
  // étape où se trouve l'utilisateur
  @Input() public readonly currentUserStep: number = 0;

  // alt des illustrations utilisées sur la page
  public imgAltText: string = 'Illustration of current step';
  // Détecte si l'utilisateur est sur mobile (pour le placement des pastilles)
  public isMobile: boolean = false;
  // Récupère toutes les subscriptions pour unsub quand il faut
  private sub$ = [];
  // nombre de sous étapes
  public nbSubSteps: number = 1;
  // sous étape à afficher
  public currentSubStep: PostReservationState;
  // Lien média - @TODO : à retirer quand on aura des variables d'img
  private rawMediaURL: string = GlobalConstantsComponent.rawMediaURL;
  public isFetchingCertificate: boolean = false;
  private certificateUrl: string;
  public contactFormUrl = 'https://form.typeform.com/to/Skse0ywG';

  constructor(
    private documentService: DocumentsService,
    private userService: UserService,
    private alertService: AlertService,
  ) {
    this.setContactFormUrl();
  }

  public getHelp(): void {
    // @ts-ignore
    if (window.HubSpotConversations) {
      // @ts-ignore
      window.HubSpotConversations.widget.open();
    }
  }

  public stateTrackBy(index: number, state: PostReservationState): number {
    return state.id;
  }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.displayedStep) {
      this.setDatas();
    }
    if (changes.currentUserStep && this.displayedStep.type !== 'single' && this.displayedStep.childs && this.displayedStep.childs.length > 0) {
      const x = this.displayedStep.childs.find(c => c.id === changes.currentUserStep.currentValue);
      if (x) {
        this.currentSubStep = x;
      } else {
        this.currentSubStep = this.displayedStep;
      }
    }
    // @TODO : optimiser pour virer le timeout
    setTimeout(() => {
      this.getContactButton();
      this.getCopyPasteButton();
      this.getRedirectBtn();
      this.getGarantieBtn();
    }, 1);

    if (this.sub$ && this.sub$.length > 0) {
      this.sub$.forEach(s => {
        if (s) {
          s.unsubscribe();
        }
      });
    }
  }

  private setDatas(): void {
    this.currentSubStep = this.displayedStep;
    if (this.displayedStep.type !== 'single' && this.displayedStep.childs && this.displayedStep.childs.length > 0) {
      this.nbSubSteps = this.displayedStep.childs.length + 1;
      if (this.locale === 'fr') {
        this.imgAltText = 'Illustration de l\'étape numéro ';
      }
      this.imgAltText += this.currentUserStep;
    }
  }


  private getContactButton(): void {
    const htmlButton = document.getElementsByClassName('contact-btn');
    if (htmlButton && htmlButton.length > 0) {
      const btn = htmlButton.item(0);
      if (btn.getAttribute('listener') !== 'true') {
        btn.addEventListener('click', () => {
          this.wantContactPage.emit(true);
        });
      }
    }
  }

  private getCopyPasteButton(): void {
    const htmlButton = document.getElementsByClassName('copy_btn');
    if (htmlButton && htmlButton.length > 0) {
      const btn = htmlButton.item(0);
      // Si c'est une balise a
      if (btn.getAttribute('href')) {
        // Récupère le content
        const copyText = btn.getAttribute('href');
        // Gère la potentielle redirection liée au href
        btn.removeAttribute('href');
        // Met le content dans le clipboard
        navigator.clipboard.writeText(copyText);
      }
    }
  }

  private getRedirectBtn(): void {
    const htmlButton = document.getElementsByClassName('redirect_btn');
    if (htmlButton && htmlButton.length > 0) {
      const btn = htmlButton.item(0);
      localStorage.setItem('redirect', btn.getAttribute('href'));
      btn.setAttribute('href', '/redirect');
    }
  }

  // @TODO : faire qu'on DL le PDF au lieu de l'ouvrir quand on clique sur le btn
  private getGarantieBtn(): void {
    const htmlButton = document.getElementsByClassName('garantie_btn');
    if (htmlButton && htmlButton.length > 0) {
      const btn = htmlButton.item(0);
      // On bloque pour éviter tout problème le temps de load le doc
      btn.classList.add('disabled');
      btn.setAttribute('target', '_blank');
      // On récupère la caution
      this.sub$.push(this.documentService.getDocuments('CTNMNT')
        .pipe(first(), finalize(() => {
          // On free le btn
          btn.classList.remove('disabled');
        }))
        .subscribe(data => {
          // S'il y a une caution, on set les informations pour le download
          if (data && data.documents && data.documents.length > 0) {
            const doc = data.documents[data.documents.length - 1];
            btn.setAttribute('href', (this.rawMediaURL + doc.pivot.path + doc.pivot.filename));
            btn.setAttribute('download', (doc.pivot.user_id + doc.key + doc.pivot.filename));
          }
        }));
    }
  }

  public getOtherSubStep(step): void {
    this.wantOtherStep.emit(step);
  }

  public downloadCertificate(): void {
    if (!this.certificateUrl) {
      this.isFetchingCertificate = true;
      let id = JSON.parse(localStorage.getItem('tempBooking')).booking_id;
      if (!id && localStorage.getItem('tempRedirect')) {
        id = parseInt(localStorage.getItem('tempRedirect'));
      }
      this.documentService.getBookingDocument(id).subscribe({
        next: (data) => {
          this.certificateUrl = this.rawMediaURL + data.data.path + data.data.filename;
          window.open(this.certificateUrl);
          this.isFetchingCertificate = false;
        },
        error: () => {
          this.alertService.openSnackBar('We couldn`t get your document, please contact your agent.', 'snack-error');
          this.isFetchingCertificate = false;
        }
      });
    } else {
      window.open(this.certificateUrl);
    }

  }

  public setContactFormUrl(): void {
    if (this.locale === 'fr') {
      this.contactFormUrl = 'https://form.typeform.com/to/vfP7UpuV';
    }
  }

}
